import ResponsiveContainer from '../../common/ResponsiveContainer';
import './Register.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPeace } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import T4Button from '../../common/T4Button';
import { register as registerApi } from '../../api';

const Register = () => {
  const screenHeigth = window.innerHeight;
  const navbarHeight = 80;

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    registerApi(data)
      .then(() => {
        window.location.href = '/';
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'md:w-auto max-w-full mx-3 my-3 md:mx-1',
          delay: 0,
          autoClose: 1000,
        });
      });
  };

  return (
    <div className='flex font-montserrat font-semibold w-full' style={{ height: `${screenHeigth - navbarHeight}px` }}>
      <div className='hidden md:flex md:max-w-[25%] lg:max-w-[50%] w-full login-image shadow-inner' />
      <div className='flex justify-center max-w-full md:max-w-[75%] lg:max-w-[50%] w-full mx-5'>
        <div className='bg-white shadow-xl w-full my-auto p-4 px-10 max-w-[500px] xl:max-w-[600px]'>
          <img src='/logo.png' alt='' width='100px' className='mx-auto' />
          <p className='text-center my-5 text-xl text-red-1'>
            Bienvenido a Turkish4Love <FontAwesomeIcon icon={faHandPeace} />
          </p>

          <p className='text-center text-red-2 font-montserrat'>
            Gracias por tu interés en ser parte de Turkish4love, para continuar debes crear tu cuenta.
          </p>
          <form className='flex flex-col' onSubmit={handleSubmit(onSubmit)}>
            <label htmlFor='email' className='text-red-1 mt-5'>
              Correo electrónico
            </label>
            <input
              type='email'
              className='login-input w-full h-9 outline-none focus:border-red-2 transition-colors pl-2 text-gray-600'
              {...register('email', { required: true })}
            />
            {errors.email && <span>Este campo es requerido</span>}

            <label htmlFor='name' className='text-red-1 mt-5'>
              Nombre
            </label>
            <input
              className='login-input w-full h-9 outline-none focus:border-red-2 transition-colors pl-2 text-gray-600'
              {...register('name', { required: true })}
            />
            {errors.name && <span>Este campo es requerido</span>}

            <label htmlFor='lastname' className='text-red-1 mt-5'>
              Apellido
            </label>
            <input
              className='login-input w-full h-9 outline-none focus:border-red-2 transition-colors pl-2 text-gray-600'
              {...register('lastname', { required: true })}
            />
            {errors.lastname && <span>Este campo es requerido</span>}

            <label htmlFor='email' className='text-red-1 mt-5'>
              Contraseña
            </label>
            <input
              type='password'
              className='login-input w-full h-9 outline-none focus:border-red-2 transition-colors pl-2 text-gray-600'
              {...register('password', { required: true })}
            />
            {errors.password && <span>Este campo es requerido</span>}
            <div className='flex items-center mt-5'>
              <label htmlFor='removeMailing' className='text-red-1 mr-3'>
                <b className='text-darkred'>NO</b> quiero recibir avisos de nuevos capítulos
              </label>

              <input type='checkbox' {...register('removeMailing')} id='removeMailing' className='outline-none p-5' />
            </div>

            <T4Button>Crear cuenta</T4Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
